import Vue from 'vue'
import VueRouter from 'vue-router'
import StandaloneGamesPage from '@/views/StandaloneGamesPage.vue'
import HomePage from '@/views/HomePage.vue'
import GameSliderPage from '@/views/GameSliderPage.vue'
import GameListScrollPage from '@/views/GameListScrollPage.vue'
import AllGamesPage from '@/views/AllGamesPage.vue'

Vue.use(VueRouter)

const routes = [
  { path: '/en-US', redirect: to => ({ path: '/', query: to.query, hash: to.hash }) },
  { path: '/en-US/*', redirect: to => ({ path: to.path.replace(/^\/en-US/i, '') || '/', query: to.query, hash: to.hash }) },
  { path: '/standalone-games', name: 'StandaloneGames', component: StandaloneGamesPage },
  {
    path: '/',
    name: 'Home',
    component: HomePage
  },
  {
    path: '/game-list-scroll',
    name: 'GameListScroll',
    component: GameListScrollPage
  },
  {
    path: '/slider',
    name: 'GameSlider',
    component: GameSliderPage
  },
  {
    path: '/all-games',
    name: 'AllGames',
    component: AllGamesPage
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router